import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api'; // <--- Import your API service

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false); // Add loading state
  const navigate = useNavigate();

  const handleLogin = async (e) => { // Make function async
    e.preventDefault();
    setError('');
    setLoading(true); // Disable button while checking

    if (!username || !password) {
      setError("Please enter both username and password.");
      setLoading(false);
      return;
    }

    try {
      // 1. Send credentials to the Backend to check them
      console.log("Sending credentials for:", username);
      const res = await api.post('token/', { username, password });

      // 2. If code reaches here, the password was CORRECT.
      // The backend returns 'access' and 'refresh' tokens.
      console.log("Login Success!");

      localStorage.setItem('access_token', res.data.access);
      localStorage.setItem('refresh_token', res.data.refresh);
      // Optional: Store username for display
      localStorage.setItem('username', username);

      // 3. Navigate to Dashboard
      window.location.href = '/dashboard';

    } catch (err) {
      console.error("Login Failed:", err);
      
      // 4. Handle Incorrect Password (401 Unauthorized)
      if (err.response && err.response.status === 401) {
        setError("❌ Invalid Username or Password.");
      } else {
        setError("⚠️ Server error. Is the backend running?");
      }
    } finally {
      setLoading(false); // Re-enable button
    }
  };

  return (
    <div className="container" style={{ maxWidth: '400px', marginTop: '100px' }}>
      <div className="card">
        <h2 style={{ textAlign: 'center' }}>SiteACT Login</h2>
        
        {error && (
          <div style={{ backgroundColor: '#fca5a5', color: '#7f1d1d', padding: '10px', borderRadius: '4px', marginBottom: '10px', textAlign:'center' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label>Username</label>
            <input 
              type="text" 
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              disabled={loading} // Prevent typing while loading
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input 
              type="password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn-primary" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Verifying...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;